var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreenUp = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 22",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25732 11.0008C2.25732 14.8367 5.01441 18.2589 8.76879 19.0613C10.6447 19.4622 12.6395 19.1921 14.3369 18.2977C15.9705 17.4369 17.2908 16.0257 18.039 14.3373C18.8175 12.5811 18.9532 10.5649 18.4223 8.71899C17.9103 6.93819 16.7866 5.3592 15.2782 4.28421C12.1246 2.03658 7.69485 2.33709 4.86909 4.98141C3.21303 6.53121 2.25732 8.73243 2.25732 11.0008ZM10.9402 7.04676L13.2414 9.29376C13.8241 9.86265 12.9413 10.7619 12.3613 10.1953L11.2002 9.0615L11.2002 14.4346C11.2002 14.8161 10.8816 15.1345 10.5002 15.1345C10.1189 15.1345 9.80031 14.8159 9.80031 14.4346L9.80031 9.08838L8.64426 10.2446C8.0697 10.8192 7.17867 9.92838 7.75323 9.35382L10.0548 7.05201C10.2986 6.80799 10.6934 6.80568 10.9402 7.04676Z",
    fill: "#11AC46"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreenUp);
export default ForwardRef;